import request from './request'
import { withWebClientMeta } from '@/utils/auth-session'

/**
 * 用户登录
 * @param {object} data - 登录参数
 * @param {string} data.phone - 手机号
 * @param {string} data.password - 密码
 * @param {string} [data.deviceId] - 设备ID
 */
export function login(data) {
  return request.post('/auth/login', withWebClientMeta(data))
}

/**
 * 选择租户（多租户登录第二步）
 * @param {object} data - 选择租户参数
 * @param {number} data.accountId - 账号ID（从登录第一步获得）
 * @param {number} data.tenantId - 选择的租户ID
 * @param {string} [data.deviceId] - 设备ID
 */
export function selectTenant(data) {
  return request.post('/auth/selectTenant', withWebClientMeta(data))
}

/**
 * 刷新Token
 * @param {object} data - 刷新参数
 * @param {string} data.refreshToken - 刷新令牌
 * @param {string} [data.deviceId] - 设备ID
 */
export function refreshToken(data) {
  return request.post('/auth/refresh', withWebClientMeta(data))
}

/**
 * 用户登出
 * @param {object} data - 登出参数
 * @param {string} data.accessToken - 访问令牌
 */
export function logout(data) {
  return request.post('/auth/logout', data)
}

/**
 * 获取当前登录用户信息
 */
export function getInfo() {
  return request.get('/auth/getInfo')
}

/**
 * 踢用户下线
 * @param {object} data - 参数
 * @param {number} data.userId - 用户ID
 * @param {string} [data.deviceId] - 设备ID，为空则踢出所有设备
 */
export function kickUser(data) {
  return request.post('/auth/kick', data)
}

/**
 * 获取最近登录日志
 */
export function getLoginLogs() {
  return request.get('/auth/loginLogs')
}

/**
 * 修改密码
 * @param {object} data - 修改密码参数
 * @param {string} data.oldPassword - 旧密码
 * @param {string} data.newPassword - 新密码（6-20位，必须包含大小写字母和数字）
 */
export function changePassword(data) {
  return request.post('/auth/changePassword', data)
}

/**
 * 忘记密码 - 发送短信验证码
 * @param {string} phone - 手机号
 */
export function sendResetSmsCode(phone) {
  return request.post('/auth/forgotPassword/sendCode', { phone })
}

/**
 * 忘记密码 - 通过短信验证码重置密码
 * @param {object} data - 重置密码参数
 * @param {string} data.phone - 手机号
 * @param {string} data.code - 短信验证码（6位数字）
 * @param {string} data.newPassword - 新密码（6-20位，须含大小写字母和数字）
 */
export function resetPasswordBySms(data) {
  return request.post('/auth/forgotPassword/resetPassword', data)
}
